var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoMini(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 380.21 228.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#10c5a8;}.cls-2{fill:#03e4b5;}.cls-2,.cls-3{fill-rule:evenodd;}.cls-3{fill:#5551ff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_1",
    "data-name": 1,
    className: "cls-1",
    d: "M195.93,0,123.62,123c13.62,18.76,24.22,39.55,35.89,59.54,6.69,10.41,13,30.4,28.68,26.68,30.76-23.81,49.2-59.5,68.77-92.32L325.18,0S210.36.36,195.93,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_2",
    "data-name": 2,
    className: "cls-2",
    d: "M0,102.54c121.52,2.44,106.57-22.4,168.34,90.22,4,7.91,13.81,19.72,23.51,13.53-23.46,22-59.76,26-90,18.66C47.42,212.1,27.06,143.5,0,102.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_3",
    "data-name": 3,
    className: "cls-3",
    d: "M271.39,124.61c6-7.88,46.11-85.3,55.22-87.14,12.07-9.29,43.92-4.51,53.6-5.66-10.69,17-19.49,34.71-29.25,52.26C332.13,124.06,312.91,127.3,271.39,124.61Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMini);
export default __webpack_public_path__ + "static/media/logo-mini.f7d81b6b2dd47fa9f047377e4c50a187.svg";
export { ForwardRef as ReactComponent };